import { Pipe, PipeTransform } from '@angular/core';
import { atsSortFn } from '../operators/sort.operator';

@Pipe({
    name: 'atsOrderByProp',
    standalone: false
})
export class AtsOrderByPropPipe implements PipeTransform {
	constructor() {}

	transform(value: any[], ...prop: string[]): any[] {
		return atsSortFn(value, ...prop);
	}
}
